/*
 * Copyright ThreatBlockr Inc 2024-2024
 * ejohnson created
 */

import Vue from 'vue'
import App from '@/App.vue'
import '@/mixins/GlobalMixin'
import '@/mixins/GlobalHelpersMixin'
import vuetify from '@/plugins/vuetify/vuetify'
import router from '@/router'
import vuex from '@/store/vuex'

import '@/directives'

import '@/helpers/filters'
import '@/plugins/branding.js'
import '@/plugins/axios.js'
import '@/plugins/highcharts'
import '@/plugins/veeValidate'
import '@/plugins/threater'

import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueTinySlider from 'vue-tiny-slider'
import vueClamp from 'vue-clamp'

// import { plugin as vueTransitionsPlugin } from '@morev/vue-transitions'
// import '@morev/vue-transitions/styles'
// import vuelidateErrorExtractor from 'vuelidate-error-extractor'

// import Button from 'primevue/button'

// Vue.component('Button', Button)

// Vue.use(PrimeVue)
// Vue.directive('tooltip', Tooltip)

// Vue.component('form-group', vuelidateErrorExtractor)


// Vue.component('form-group', vuelidateErrorExtractor)

// Vue.use(directives)
/*
 Vue.use(vueTransitionsPlugin, {
 // Plugin options (optional, described below)
 })
 */

Vue.component('tiny-slider', VueTinySlider)
Vue.component(VueQrcode.name, VueQrcode)

Vue.config.productionTip = false


Vue.prototype.$suppressDebug = false
// Vue.prototype.$axiosDelay = 2000


Vue.prototype.$environment = process.env.NODE_ENV
// Vue.prototype.$allowProd = false

const fixVueClampErr = (comp) => {
    const oldUpdate = comp.methods.update
    comp.methods.update = function() {
        window.requestAnimationFrame(oldUpdate.bind(this))
    }
}

fixVueClampErr(vueClamp)
Vue.component('v-clamp', vueClamp)

export const app = new Vue({
    router,
    store: vuex,
    vuetify,
    render: h => h(App),
}).$mount('#app')
//# sourceMappingURL=main.js.map
